import { useEffect, useState } from "react";
import api from "@/lib/apiClient";
import { User } from "lucide-react";

/** Fetches an authenticated image/file as a blob (img src cannot send headers). */
export default function AuthImage({ path, alt = "", className = "", fallbackIcon = true }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let revoked = null;
    let active = true;
    if (!path) { setUrl(null); return; }
    setError(false);
    api.get(path, { responseType: "blob" })
      .then((res) => {
        if (!active) return;
        const objUrl = URL.createObjectURL(res.data);
        revoked = objUrl;
        setUrl(objUrl);
      })
      .catch(() => active && setError(true));
    return () => { active = false; if (revoked) URL.revokeObjectURL(revoked); };
  }, [path]);

  if (url && !error) return <img src={url} alt={alt} className={className} />;
  if (fallbackIcon) {
    return (
      <div className={`flex items-center justify-center bg-slate-100 text-slate-400 ${className}`}>
        <User className="h-1/2 w-1/2" />
      </div>
    );
  }
  return null;
}
